/* TreeViewComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
// const InfiniteTree = require("infinite-tree");
const Renderer = require("./TreeViewRenderer");
const _ = require("lodash");

class TreeViewComponent extends EventEmitter {
    constructor(configOptions) {
        super();

        this._gridKey = _.get(configOptions, "gridKey");
        this._autoOpen = _.get(configOptions, "autoOpen", true);
        this._selectable = _.get(configOptions, "selectable", true);
        this._data = _.get(configOptions, "pageFeed", []);
        this._simpleTree = _.get(configOptions, "simple", false);
        this._treeActions = _.get(configOptions, "actions", []);
        this._defaultSelection = _.get(configOptions, "defaultSelection", "");
        this._readonly = _.get(configOptions, "readonly", false);

        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    get readonly() {
        return this._readonly;
    }

    get data() {
        return this._data;
    }

    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(() => {
            this._renderer = undefined;
            this.removeAllListeners();
        });
    }
    /*******************************************/
    /* END PUBLIC API ACTION METHODS */
    /* START PUBLIC API ACTION METHODS */
    /*******************************************/
    launchEditor(editorState, editorName, opts) {
        this.emit("LaunchEditor", editorState, editorName, opts);
    }

    getTreeNodes() {
        return this.renderer.tree.nodes;
    }
    async updateNode(data = {}) {
        await this.renderer._updateNode(data);
    }
    async removeNode(data) {
        await this.renderer._removeNode(data);
    }
    updateTree(data) {
        this._data = data;
        this.renderer._updateTree(data);
    }
    currentSelection() {
        return this.renderer._currentNode;
    }
    setSelectedNode(newNode) {
        this.renderer.tree.selectNode(newNode);
    }
    resetSelection() {
        this.renderer._resetSelection();
    }

    setReadOnly(state) {
        state = Boolean(state);
        if (this._readonly !== state) {
            this._readonly = state;
            this._triggerReadOnly(state);
        }
    }

    /*******************************************/
    /* END PUBLIC API ACTION METHODS */
    /*******************************************/
    /**
     * Triggered when the user has selected Path in the treeview
     * @param selectedPaths {Array} - An object of path representing the object of the selected Path
     * @private
     */
    _triggerUserSelectedPath(path) {
        this.emit("UserSelectedPath", path);
    }
    _triggerUserSelectedPathForEdit(path) {
        this.emit("UserSelectedPathForEditName", path);
    }
    _triggerUserSelectedPaths(paths) {
        this.emit("UserSelectedPaths", paths);
    }
    _dragDroped(draggableTarget, droppableTarget, node) {
        this.emit("DragDroped", { draggableTarget, droppableTarget, node });
    }
    _triggerDelete(path) {
        this.emit("DeletePath", path);
    }
    _triggerOpenNode(path) {
        this.emit("OpenPath", path);
    }
    _triggerReadOnly(state) {
        this.emit("ReadOnly", state);
    }
    _triggerNothingSelected() {
        this.emit("NothingSelected");
    }
}
module.exports = TreeViewComponent;
